import { Box, Typography, Button } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../../context/language/language';
import { TitleModal } from '../../../MyAccount/common';
import { choiceSelectionModalSize } from '../modalSize';
import { getImageURL } from '../../../../utils/getImageURL';

import { useReorder } from '../../../common/hook/useReorder';

const Icon = getImageURL('/icon/clear-cart.svg');

const useStyle = makeStyles((theme, disabled) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: choiceSelectionModalSize.width,
      padding: 24,
      boxSizing: 'border-box',
    },
  },
  customTitleModal: {
    ...theme.custom.fonts.header3,
  },
  textDesc: {
    whiteSpace: 'pre-line'
  },
  btnSubmit: {
    width: '100%',
    backgroundColor: theme.custom.colors.green600,
    color: disabled ? theme.custom.colors.grey500 : theme.custom.colors.white,
    height: 44,
    textTransform: 'none',
    ...theme.custom.radius.m,
    ...theme.custom.fonts.header6,

    '&:hover': {
      backgroundColor: theme.custom.colors.green400,
    },
  },
  btnCancel: {
    width: '100%',
    marginRight: 8,
    backgroundColor: theme.custom.colors.grey75,
    height: 44,
    textTransform: 'none',
    ...theme.custom.radius.m,
    ...theme.custom.fonts.header6,
  }
}));

function ReorderClearCartDialog(props) {
  const word = useLanguage();
  const classes = useStyle();
  const reorder = useReorder();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={classes.root}
    >
      <img src={Icon} alt="alt icon" />
      <Box mt={2} mb={1}>
        <TitleModal className={classes.customTitleModal}>{word('Alert.ClearCart.Title')}</TitleModal>
      </Box>
      <Box mb={2}>
        <center>
          <Typography className={classes.textDesc} dangerouslySetInnerHTML={{ __html: word('Alert.ClearCart.Description') }} />
        </center>
      </Box>
      <Box
        flexDirection="row"
        display="flex"
        justifyContent="center"
        width="100%"
      >
        <Button
          className={classes.btnCancel}
          id="cancel"
          data-cta-name-en="Cancel"
          data-cta-name-th="ยกเลิก"
          data-cta-type="Button"
          onClick={props.onClose}
        >
          {word('General.Cancel')}
        </Button>
        <Button
          className={classes.btnSubmit}
          id="new-cart"
          data-cta-name-en="newCart"
          data-cta-name-th="เริ่มตะกร้าใหม่"
          data-cta-type="Button"
          onClick={reorder.newCartReorder}
        >
          {' '}
          {word('Reorder.Warning.New')}
        </Button>
      </Box>
    </Box>
  );
}

export default ReorderClearCartDialog;
